import {
  HttpReadWriteStore,
  ProjectionEntityStore,
} from '@soniq/public-resource'
import {
  contactSchema,
  ContactSchema,
  validateContact,
} from '@soniq/schema-connection'

export class ContactHttpStore extends HttpReadWriteStore<ContactSchema> {
  static new() {
    return new ContactHttpStore('contact', validateContact)
  }
}

export class ContactProjectionStore extends ProjectionEntityStore<ContactSchema> {
  static new() {
    return new ContactProjectionStore('contact', contactSchema)
  }
}
